import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { filterUndefined } from '@costar-ui/utils';
import React, { forwardRef, useMemo } from 'react';
import CardBody from './card-body/card-body.esm.js';
import CardContextProvider from './card-context/card-context.esm.js';
import CardFooter from './card-footer/card-footer.esm.js';
import CardHeader from './card-header/card-header.esm.js';
import CardImage from './card-image/card-image.esm.js';
import CardSlot from './card-slot/card-slot.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import { useComponentVariant } from '../../theme/variant.context.esm.js';
import { usePopoverContext } from '../popover/popover-context.esm.js';

var _excluded = ["variant"],
  _excluded2 = ["bordered", "children", "className", "direction", "canShrink", "fullWidth", "fullHeight", "fontFamily", "fontSize", "color", "radius", "shadow", "padding", "withDivider"];
var CardRoot = /*#__PURE__*/forwardRef(function CardRoot(_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'std-border-divider' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var variantProps = useComponentVariant('Card', variant);
  var theme = useComponentTheme('Card');
  var popoverContext = usePopoverContext();
  var _variantProps$filterU = _objectSpread2(_objectSpread2(_objectSpread2({}, variantProps), filterUndefined(popoverContext || {})), props),
    bordered = _variantProps$filterU.bordered,
    children = _variantProps$filterU.children,
    _variantProps$filterU2 = _variantProps$filterU.className,
    className = _variantProps$filterU2 === void 0 ? '' : _variantProps$filterU2,
    _variantProps$filterU3 = _variantProps$filterU.direction,
    direction = _variantProps$filterU3 === void 0 ? 'vertical' : _variantProps$filterU3,
    canShrink = _variantProps$filterU.canShrink,
    fullWidth = _variantProps$filterU.fullWidth,
    fullHeight = _variantProps$filterU.fullHeight,
    fontFamily = _variantProps$filterU.fontFamily,
    fontSize = _variantProps$filterU.fontSize,
    color = _variantProps$filterU.color,
    radius = _variantProps$filterU.radius,
    shadow = _variantProps$filterU.shadow,
    padding = _variantProps$filterU.padding,
    withDivider = _variantProps$filterU.withDivider,
    rest = _objectWithoutProperties(_variantProps$filterU, _excluded2);
  // const id = usePropId(props.id)

  var contextValue = useMemo(function () {
    return {
      radius: radius,
      padding: padding,
      withDivider: withDivider
    };
  }, [radius, padding, withDivider]);
  var classes = useMemo(function () {
    return theme.root({
      bordered: bordered,
      canShrink: canShrink,
      className: className,
      color: color,
      direction: direction,
      fontFamily: fontFamily,
      fontSize: fontSize,
      fullHeight: fullHeight,
      fullWidth: fullWidth,
      radius: radius,
      shadow: shadow,
      withDivider: !!withDivider
    });
  }, [bordered, canShrink, className, color, direction, fontFamily, fontSize, fullHeight, fullWidth, radius, shadow, theme, withDivider]);
  return /*#__PURE__*/React.createElement(CardContextProvider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", _extends({
    // id={id}
    ref: ref,
    className: "csg-tw-card-root ".concat(classes)
  }, rest), children));
});
var Card = Object.assign(CardRoot, {
  Body: CardBody,
  Footer: CardFooter,
  Header: CardHeader,
  Image: CardImage,
  Slot: CardSlot
});
Card.displayName = 'Card';

export { Card as default };
//# sourceMappingURL=card.esm.js.map
